import { FC } from "react";
import "./loader.component.css"
type LoaderProps = {
  message?: string;
};

export const Loader: FC<LoaderProps> = ({ message = "در حال بارگذاری..." }) => {
  return (
    <div className="flex justify-center items-center p-8">
      <div className="text-center">
        {/* <div className="animate-spin rounded-full h-8 w-8 border-b-4 border-primary mb-3 mx-auto"></div>
         */}

        <div className="lds-spinner opacity-80"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <p className="font-bold text-lg text-gray-500/80" >{message}</p>
      </div>
    </div>
  );
};
